import React, { useState, useRef, useEffect } from "react";
import { encode, decode } from "js-base64";
import '../styles/Header.css';
import '../styles/Widget.css';
import Config from "../Config.js";
import RequestHelper from "../utils/RequestHelper.js";
import Commons from "../utils/Commons.js";
import { OAuthConfig } from "./oauth/config/config";
import { generateCodeChallenge, generateCodeVerifier } from "./oauth/auth/PkceGenerate.js";
import { isOauth, isBasicAuth, checkToken, ADOxxLogout, ClearLocalstorageBeforeLogin } from "./oauth/OAuth";
import { toBool } from "../functions/dataParse";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import { TfiClose } from "react-icons/tfi";



const Login = (props) =>
{
    const [urlToADO, setUrlToADO] = useState("");
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [displayError, setDisplayError] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [errorMessageDefault, setErrorMessageDefault] = useState(Config.strings.errorMessages.login.default);
    const [validationInProgress, setValidationInProgress] = useState(false);
    const passInputRef = useRef(null);
    const [baseURL, setBaseURL] = useState(() => localStorage.getItem('baseURL') || '');
    const [notification, setNotification] = useState({});

    const [token, setToken] = useState(() => localStorage.getItem('SSO-ADOxx') || null);
    const [credentials, setCredentials] = useState(() => localStorage.getItem('SSO-Credentials')?.length > 0 && JSON.parse(localStorage.getItem('SSO-Credentials')) || {});
    const [codeVerifier, setCodeVerifier] = useState(() => localStorage.getItem('SSO-codeVerifier') || '');
    const [codeChallenge, setCodeChallenge] = useState(() => localStorage.getItem('SSO-codeChallenge') || '');

    const [isOauthLogin, setOauthLogin] = useState(() => toBool(localStorage.getItem("loginMethod")) || false);

    useEffect(() =>
    {
        const sCredentials = localStorage.getItem('SSO-Credentials') || "";
        if (sCredentials.length > 0)
        {
            try
            {
                const sCredentialsParse = JSON.parse(sCredentials)

                if (Object.keys(sCredentialsParse).length === 0)
                {
                    ADOxxLogout()
                }
            } catch (e) { }
        }

    }, [])

    useEffect(() =>
    {
        if (localStorage.getItem('SSO-codeVerifier') || localStorage.getItem('SSO-codeChallenge')) return;
        const generatePKCE = () =>
        {
            const newCodeVerifier = generateCodeVerifier();
            const newCodeChallenge = generateCodeChallenge(newCodeVerifier);
            localStorage.setItem('SSO-codeVerifier', newCodeVerifier)
            localStorage.setItem('SSO-codeChallenge', newCodeChallenge)
            setCodeVerifier(newCodeVerifier);
            setCodeChallenge(newCodeChallenge);
        };

        generatePKCE();
    }, [])

    useEffect(() =>
    {
        const handleStorageChange = (event) =>
        {
            if (event.key === 'SSO-ADOxx')
            {
                setToken(localStorage.getItem('SSO-ADOxx'));
            }
            if (event.key === 'baseURL')
            {
                setBaseURL(localStorage.getItem('baseURL'));
            }
            if (event.key === 'SSO-Credentials')
            {
                console.log('success logged id')
            }
        };

        window.addEventListener('storage', handleStorageChange);

        return () =>
        {
            window.removeEventListener('storage', handleStorageChange);
        };
    }, []);

    useEffect(() =>
    {
        const ADOxxGetAccessAndRefreshToken = async () =>
        {
            try
            {
                if (token)
                {
                    const response = await fetch(Config.baseURL.concat('/oauth2/token'), {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/x-www-form-urlencoded'
                        },
                        body: `grant_type=authorization_code&code=${token}&client_id=${Config.env.WRC_OAUTH_ID}&code_verifier=${localStorage.getItem('SSO-codeVerifier')}`
                    });

                    if (response.ok)
                    {
                        const data = await response.json();
                        setCredentials(data);
                        localStorage.setItem('SSO-Credentials', JSON.stringify(data));
                        localStorage.removeItem('SSO-ADOxx');
                    } else
                    {
                        console.error('Token request failed');
                    }
                }
            } catch (error)
            {
                console.error('Error during token request:', error);
            }
        };

        ADOxxGetAccessAndRefreshToken();
    }, [token, OAuthConfig.httpData.baseURL]);

    const windowRedirect = () =>
    {
        try
        {
            Office.context.ui.displayDialogAsync(Config.OAuth.taskpane, { height: 60, width: 40 });
        } catch (e)
        {
            console.log(e);
        }
    };


    useEffect(() =>
    {

        const call = async () =>
        {
            if (isOauth() && localStorage.getItem("SSO-Credentials"))
            {
                await checkToken()
                    .then((result) =>
                    {
                        if (result.status === "success")
                        {
                            window.location.reload();
                        }
                        if (!result)
                        {
                            return false;
                        }
                    })

            }
        }

        call();

    }, [])

    useEffect(() =>
    {
        if (isBasicAuth())
        {
            Config.getConfig();
            checkCurrentToken();
        }
    }, []);

    const checkCurrentToken = async () =>
    {
        setValidationInProgress(true);
        try
        {
            let aData = await RequestHelper.sendRequestSimple({
                request: Commons.createGatewayRequestUrl({
                    url: Config.anpRequestUrl.testAuth,
                    endpoint: Config.requestSession
                }),
                dataType: "text",
            });

            if (aData && typeof aData === "string")
            {
                aData = JSON.parse(aData);
            }

            if (!aData.isErr && aData.token && aData.expire)
            {
                localStorage["gateway_token"] = JSON.stringify(aData);
                props.successCallback();
            } else
            {
                localStorage.removeItem("gateway_token");
                localStorage.removeItem("user_name");
            }

            setValidationInProgress(false);
        } catch (aEx)
        {
            console.error(aEx.message);
            setValidationInProgress(false);
        }
    }

    const checkUrlAdo = () =>
    {
        let sUrlProvided = urlToADO;

        if (typeof sUrlProvided === "string" && sUrlProvided.length > 0)
        {
            if (sUrlProvided.startsWith("http"))
            {
                Config.setUrlAdo(sUrlProvided);
            } else
            {
                let sErrMessage = Config.strings.errorMessages.login.urlNotValid;
                setDisplayError(true);
                setErrorMessage(sErrMessage);
                throw new Error(sErrMessage);
            }
        } else
        {
            if (!Config.baseURL)
            {
                let sErrMessage = Config.strings.errorMessages.login.urlEmpty;
                setDisplayError(true);
                setErrorMessage(sErrMessage);
                throw new Error(sErrMessage);
            }
        }
    }

    const validateInputs = async () =>
    {

        if (isOauth() && localStorage.getItem("SSO-Credentials"))
        {
            await checkToken()
                .then((result) =>
                {
                    if (!result)
                    {
                        return false;
                    }
                })

        }

        setValidationInProgress(true);
        try
        {
            checkUrlAdo();

            let aCredentials = {
                username: username,
                password: password
            };

            if (isOauth() && !localStorage.getItem("SSO-Credentials"))
            {
                windowRedirect();
                setValidationInProgress(false);
                return;
            }

            let sErrMessage = "";
            if (isBasicAuth())
            {
                for (let sKey in aCredentials)
                {
                    if ((sKey === "username" || sKey === "password") && !aCredentials[sKey])
                    {
                        sErrMessage = Config.strings.errorMessages.login.credentialEmpty.replace(/%s/g, sKey);
                        setDisplayError(true);
                        setErrorMessage(sErrMessage);
                        throw new Error(sErrMessage);
                    }
                }
            }

            let aData;
            if (isBasicAuth())
            {
                aData = await RequestHelper.sendRequestSimple({
                    request: Commons.createGatewayRequestUrl({
                        url: Config.anpRequestUrl.testAuth,
                        endpoint: Config.requestSession,
                        preventToken: true
                    }),
                    dataType: "json",
                    headers: {
                        "Authorization": "Basic " + encode(username + ":" + password)
                    }
                });
            }

            if (isOauth())
            {
                const Bearer = JSON.parse(localStorage.getItem("SSO-Credentials"));

                aData = await RequestHelper.sendRequestSimple({
                    request: Commons.createGatewayRequestUrl({
                        url: Config.anpRequestUrl.testAuth,
                        endpoint: Config.requestSession,
                        preventToken: true
                    }),
                    headers: {
                        "Authorization": "Bearer " + Bearer?.access_token
                    }
                });
            }

            if (aData.isErr)
            {
                if (aData.message === "401: unauthorized")
                {
                    sErrMessage = Config.strings.errorMessages.login.credentialNotValid;
                    setDisplayError(true);
                    setErrorMessage(sErrMessage);
                    throw new Error(sErrMessage);
                } else
                {
                    setDisplayError(true);
                    setErrorMessage(errorMessageDefault);
                    throw new Error(aData.message);
                }
            }

            localStorage["user_name"] = username;
            localStorage["gateway_token"] = JSON.stringify(aData);
            setValidationInProgress(false);
            props.successCallback();
        } catch (aEx)
        {
            console.error(aEx.message);
            setValidationInProgress(false);
            // ADOxxLogout(); //todo asy
        }
    }

    const resetErrorDisplay = () =>
    {
        if (displayError)
        {
            setDisplayError(false);
        }
    }

    const setCredentialsState = (event, type) =>
    {
        if (type === "username")
        {
            setUsername(event.target.value);
            passInputRef.current.value = "";
        } else if (type === "password")
        {
            setPassword(event.target.value);
        }
    }

    const URLparse = (sURL) =>
    {

        try
        {
            const url = new URL(sURL);
            const filteredPath = url.pathname
                .split('/')
                .filter(item => item.trim() !== '' && item !== null && item !== undefined)
                .filter(path => !path.includes('.'));

            const cleanPath = filteredPath.join('/');
            const newUrl = `${url.origin}/${cleanPath}`;

            resetErrorDisplay();

            if (newUrl.endsWith('/'))
            {
                return newUrl.slice(0, -1);
            }

            return newUrl;
        } catch (e)
        {
            setDisplayError(true);
            setErrorMessage(Config.strings.errorMessages.login.urlNotValid);
            return sURL;
        }

    }

    const handleBaseURLChange = (e) =>
    {
        setBaseURL(e.target.value);
    };

    useEffect(() =>
    {
        if (isOauth() && localStorage.getItem("SSO-Credentials"))
        {
            validateInputs();
        }
    }, [credentials])

    const isOauthLoginHandler = () =>
    {
        const status = isOauthLogin;

        if (status)
        {
            localStorage.setItem("loginMethod", "false") //basic
        } else
        {
            localStorage.setItem("loginMethod", "true") //oauth
        }

        setOauthLogin(!status);


    }

    const showHiddenMessage = (aParams) =>
    {
        if (!aParams)
        {
            return;
        }

        setNotification(aParams);
    }

    const hideHiddenMessage = () =>
    {
        setNotification({});
    }

    return (
        <div className="wrcWidget">
            {displayError && <h4 className="App__errorMessage">
                {errorMessage ? errorMessage : errorMessageDefault}
            </h4>}
            <h2 className="ms-font-l ms-fontWeight-semilight ms-fontColor-neutralPrimary ms-u-slideUpIn20 wrcWidget__label">
                {props.message}
            </h2>
            <input
                className="wrcWidget__input"
                list="urlCache"
                placeholder={Config.baseURL ? Config.baseURL : Config.strings.login.placeholders.url}
                value={baseURL}
                onChange={handleBaseURLChange}
                onBlur={(event) =>
                {
                    setUrlToADO(URLparse(event.target.value));
                }}
            />
            <datalist id="urlCache">
            </datalist>
            {!isOauthLogin &&
                <div className="wrcCredentials">
                    <input
                        className="wrcWidget__input"
                        placeholder={Config.strings.login.placeholders.user}
                        onChange={(event) =>
                        {
                            localStorage.setItem("loginMethod", "false"); //basic auth
                            setCredentialsState(event, "username");
                            if(event.target.value.length > 0){
                                setDisplayError(false);
                                setErrorMessage("");
                            }
                        }}
                    />
                    <input
                        className="wrcWidget__input"
                        placeholder={Config.strings.login.placeholders.pass}
                        ref={passInputRef}
                        type="password"
                        onChange={(event) =>
                        {
                            setCredentialsState(event, "password")
                            if(event.target.value.length > 0){
                                setDisplayError(false);
                                setErrorMessage("");
                            }
                        }}
                    />
                </div>
            }
            <div className="wrcLabel">
                <label>
                    OAuth login
                    <input type="checkbox"
                        checked={isOauthLogin}
                        onChange={() =>
                        {
                            isOauthLoginHandler()
                            resetErrorDisplay();
                        }}
                    />
                </label>
                <button className="wrcInformation--button" onClick={() =>
                {
                    showHiddenMessage({
                        id: "wrcModal",
                        heading: Config.strings.modals.alerts.alertHeadingLabelInformation,
                        message: Config.strings.messages.login.OAuthTextHelper
                    })
                }}>
                    <FontAwesomeIcon icon={faInfoCircle} style={{ color: "black" }} />
                </button>
            </div>
            {

                Object.keys(notification).length !== 0 &&
                <div id={notification.id || ""} className="wrcInformation">
                    <div className="wrcInformation--header">
                        <span>{notification.heading || ""}</span>
                        <button className="wrcInformation--header-closeButton" onClick={hideHiddenMessage}>
                            <TfiClose />
                        </button>
                    </div>
                    <div className="wrcInformation--hiddenContent ms-font-l ms-fontWeight-semilight ms-fontColor-neutralPrimary ms-u-slideUpIn20">
                        <span>{notification.message || ""}</span>
                    </div>
                </div>

            }
            <div style={{ height: "40px" }}>
                {!validationInProgress ? (
                    <button
                        className="wrcButton wrcButton--lightGrey wrcButton--center wrcButton--big wrcButton--start"
                        onClick={(clickEvent) =>
                        {
                            ClearLocalstorageBeforeLogin();
                            !displayError && validateInputs();
                        }}
                    >
                        {Config.strings.login.startBtn}
                    </button>
                ) : (
                    <h3 className="App__infoMessage">{Config.strings.messages.login.inProgress}</h3>
                )}
            </div>
        </div>
    );
}

export default Login;
